import React from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  CircularProgress,
  TableCell,
  TableRow,
} from "@mui/material";

interface PlanEditFormProps {
  editPlanData: any;
  planStatusOptions: any[];
  templates: any[];
  templatesLoading: boolean;
  loading: boolean;
  loadingPlan: boolean;
  onEditPlanChange: (field: string, value: string) => void;
  onUpdatePlan: (vehiclemodelid: number) => void;
  onCancelEdit: () => void;
  section: number;
}

const PlanEditForm: React.FC<PlanEditFormProps> = ({
  editPlanData,
  planStatusOptions,
  templates,
  templatesLoading,
  loading,
  loadingPlan,
  onEditPlanChange,
  onUpdatePlan,
  onCancelEdit,
  section,
}) => {
  return (
     <TableRow sx={{ 
       backgroundColor: "rgba(13,44,90,0.05)",
       borderTop: "2px solid rgba(13,44,90,0.2)",
       "& .MuiTableCell-root": {
         padding: "8px 12px",
         borderBottom: "none",
         verticalAlign: "middle"
       }
     }}>
      <TableCell sx={{ textAlign: "center" }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          value={editPlanData.planName}
          onChange={(e) => onEditPlanChange("planName", e.target.value)}
          placeholder="Plan Name"
          autoComplete="off"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
             },
             "& .MuiFormLabel-asterisk": {
               color: "red",
             },
           }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="number"
          value={editPlanData.duration}
          onChange={(e) => onEditPlanChange("duration", e.target.value)}
          placeholder="Duration (Days)"
          autoComplete="off"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
                 "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                   WebkitAppearance: "none",
                   margin: 0,
                 },
                 "&[type=number]": {
                   MozAppearance: "textfield",
                 },
               },
             },
           }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="number"
          value={editPlanData.kmLimit}
          onChange={(e) => onEditPlanChange("kmLimit", e.target.value)}
          placeholder="KM Limit"
          autoComplete="off"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
                 "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                   WebkitAppearance: "none",
                   margin: 0,
                 },
                 "&[type=number]": {
                   MozAppearance: "textfield",
                 },
               },
             },
           }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="number"
          value={editPlanData.price}
          onChange={(e) => onEditPlanChange("price", e.target.value)}
          placeholder="Price"
          autoComplete="off"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
                 "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                   WebkitAppearance: "none",
                   margin: 0,
                 },
                 "&[type=number]": {
                   MozAppearance: "textfield",
                 },
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
              
             },
             "& .MuiFormLabel-asterisk": {
               color: "red",
             },
           }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="number"
          value={editPlanData.processing_fees || ""}
          onChange={(e) => onEditPlanChange("processing_fees", e.target.value)}
          placeholder="Processing Fees"
          autoComplete="off"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
                 "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                   WebkitAppearance: "none",
                   margin: 0,
                 },
                 "&[type=number]": {
                   MozAppearance: "textfield",
                 },
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
             },
           }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="number"
          value={editPlanData.refundable_amount || ""}
          onChange={(e) => onEditPlanChange("refundable_amount", e.target.value)}
          placeholder="Refundable Amount"
          autoComplete="off"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "12px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "12px",
                 textAlign: "center",
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
             },
           }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <FormControl
          fullWidth
          size="small"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
             },
             "& .MuiInputLabel-root": {
               fontSize: "13px",
             },
             "& .MuiInputLabel-asterisk": {
               color: "red !important",
             },
           }}
        >
          <InputLabel
            sx={{
              fontSize: "13px",
              "&.MuiInputLabel-asterisk": {
                color: "red !important",
              },
              "& .MuiInputLabel-asterisk": {
                color: "red !important",
              },
            }}
          >
            Template
          </InputLabel>
          <Select
            value={editPlanData.template}
            onChange={(e) => onEditPlanChange("template", e.target.value)}
            label="Template"
            sx={{
              fontSize: "13px",
              textAlign: "center",
              "& .MuiSelect-select": {
                padding: "6px 10px",
                fontSize: "13px",
                textAlign: "center",
              },
            }}
          >
            {templatesLoading ? (
              <MenuItem value="" disabled>
                Loading templates...
              </MenuItem>
            ) : templates && templates.length > 0 ? (
              templates.map((template) => (
                <MenuItem
                  key={template.ratetemplatemasterid}
                  value={template.ratetemplatemasterid}
                >
                  {template.templatename}
                </MenuItem>
              ))
            ) : (
              <></>
            )}
          </Select>
        </FormControl>
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <FormControl
          fullWidth
          size="small"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
             },
             "& .MuiInputLabel-root": {
               fontSize: "13px",
             },
             "& .MuiInputLabel-asterisk": {
               color: "red !important",
             },
           }}
        >
          <InputLabel
            sx={{
              fontSize: "13px",
              "&.MuiInputLabel-asterisk": {
                color: "red !important",
              },
              "& .MuiInputLabel-asterisk": {
                color: "red !important",
              },
            }}
          >
            Status
          </InputLabel>
          <Select
            value={editPlanData.status}
            onChange={(e) => onEditPlanChange("status", e.target.value)}
            label="Status"
            sx={{
              fontSize: "13px",
              textAlign: "center",
              "& .MuiSelect-select": {
                padding: "6px 10px",
                fontSize: "13px",
                textAlign: "center",
              },
            }}
          >
            {planStatusOptions && planStatusOptions.length > 0 ? (
              planStatusOptions.map((statusOption) => (
                <MenuItem
                  key={statusOption.codevalue}
                  value={statusOption.codedisplayname}
                >
                  {statusOption.codedisplayname}
                </MenuItem>
              ))
            ) : (
              <>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="InActive">InActive</MenuItem>
                <MenuItem value="Archived">Archived</MenuItem>
                <MenuItem value="Draft">Draft</MenuItem>
                <MenuItem value="No Plans">No Plans</MenuItem>
              </>
            )}
          </Select>
        </FormControl>
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <FormControl
          fullWidth
          size="small"
           sx={{
             width: "100%",
             "& .MuiOutlinedInput-root": {
               borderRadius: "6px",
               fontSize: "13px",
               "& .MuiOutlinedInput-input": {
                 padding: "6px 10px",
                 fontSize: "13px",
                 textAlign: "center",
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "rgba(0,0,0,0.4)",
               },
             },
             "& .MuiInputLabel-root": {
               fontSize: "13px",
             },
             "& .MuiInputLabel-asterisk": {
               color: "red !important",
             },
           }}
        >
          <InputLabel
            sx={{
              fontSize: "13px",
              "&.MuiInputLabel-asterisk": {
                color: "red !important",
              },
              "& .MuiInputLabel-asterisk": {
                color: "red !important",
              },
            }}
          >
            Popular
          </InputLabel>
          <Select
            value={editPlanData.popular}
            onChange={(e) => onEditPlanChange("popular", e.target.value)}
            label="Popular"
            sx={{
              fontSize: "13px",
              textAlign: "center",
              "& .MuiSelect-select": {
                padding: "6px 10px",
                fontSize: "13px",
                textAlign: "center",
              },
            }}
          >
            <MenuItem value="True">True</MenuItem>
            <MenuItem value="False">False</MenuItem>
          </Select>
        </FormControl>
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            gap: 0.5,
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "nowrap",
            width: "110%"
          }}
        >
          <Button
            size="small"
            variant="contained"
            disabled={loading || loadingPlan}
            onClick={() => onUpdatePlan(section as number)}
            sx={{
              backgroundColor: "rgba(13,44,90,1)",
              fontSize: "11px",
              minWidth: "auto",
              width: "auto",
              height: "28px",
              borderRadius: "6px",
              fontWeight: 500,
              textTransform: "none",
              boxShadow: "0 2px 4px rgba(13,44,90,0.3)",
              px: 1,
              "&:hover": {
                backgroundColor: "rgba(13,44,90,0.9)",
                boxShadow: "0 4px 8px rgba(13,44,90,0.4)"
              },
              "&:disabled": {
                backgroundColor: "rgba(13,44,90,0.5)",
                boxShadow: "none"
              }
            }}
          >
            {loading ? (
              <CircularProgress size={12} color="inherit" />
            ) : (
              "Update"
            )}
          </Button>
          <Button
            size="small"
            variant="outlined"
            disabled={loading || loadingPlan}
            onClick={onCancelEdit}
            sx={{
              borderColor: "rgba(13,44,90,1)",
              color: "rgba(13,44,90,1)",
              fontSize: "11px",
              minWidth: "auto",
              width: "auto",
              height: "28px",
              borderRadius: "6px",
              fontWeight: 500,
              textTransform: "none",
              px: 1,
              "&:hover": {
                borderColor: "rgba(13,44,90,1)",
                backgroundColor: "transparent"
              },
              "&:disabled": {
                borderColor: "rgba(13,44,90,0.5)",
                color: "rgba(13,44,90,0.5)"
              }
            }}
          >
            Cancel
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default PlanEditForm;
